import script from "./IfcPropertiesPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./IfcPropertiesPanel.vue?vue&type=script&setup=true&lang=ts"

import "./IfcPropertiesPanel.vue?vue&type=style&index=0&id=87f940a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87f940a0"]])

export default __exports__